import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";

import { CatalogueActions } from "../actions";
import { CategoryService } from "../../../routes/catalog/services/category.service";

@Injectable({
  providedIn: "root",
})
export class CatalogueEffects {
  private actions$ = inject(Actions);
  private categoryService = inject(CategoryService);

  listCategoryAttempt$ = createEffect(() =>
    this.actions$.pipe(
      ofType<CatalogueActions.ListAttempt>(CatalogueActions.TYPES.ListAttempt),
      switchMap((action: CatalogueActions.ListAttempt) => {
        return this.categoryService.index().pipe(
          map((response) => new CatalogueActions.ListSuccess(response)),
          catchError((response) => {
            console.error(response);
            return of(new CatalogueActions.ListFailure(response));
          }),
        );
      }),
    ),
  );
}
